// Mock data for La Bodega Restaurant Website

// =============================================
// IMAGE CONFIGURATION — Change any image here!
// =============================================
// Just replace the URL to swap an image.
// Section names tell you where each image appears.
//
export const siteImages = {
  // HOME PAGE
  homeHero: "https://images.unsplash.com/photo-1653611540493-b3a896319fbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxNZWRpdGVycmFuZWFuJTIwY3Vpc2luZXxlbnwwfHx8fDE3NzYxMTI0MTV8MA&ixlib=rb-4.1.0&q=85&w=1920",
  homeWelcome: "https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/x3qyj3la_Screenshot%202026-04-13%20at%2023.22.40.png",
  homeTerrace: "https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/s0s0wyqc_Gemini_Generated_Image_o7qpfeo7qpfeo7qp%20%281%29.png",
  homeCta: "https://images.unsplash.com/photo-1710886250891-18ba7c38c2be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxTcGFuaXNoJTIwcmVzdGF1cmFudCUyMGludGVyaW9yfGVufDB8fHx8MTc3NjExMjQzNHww&ixlib=rb-4.1.0&q=85&w=1920",

  // RESTAURANT PAGE
  restaurantHero: "https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/9o8i2dj7_Gemini_Generated_Image_inhfmyinhfmyinhf.png",
  restaurantAbout: "https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/5f0ogplh_Screenshot%202026-04-13%20at%2023.21.44.png",
  restaurantPhoto1: "https://images.unsplash.com/photo-1634736794027-3297ad344057?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxyZXN0YXVyYW50JTIwdGVycmFjZXxlbnwwfHx8fDE3NzYxMTI0MTl8MA&ixlib=rb-4.1.0&q=85&w=800",
  restaurantPhoto2: "https://images.unsplash.com/photo-1565599837634-134bc3aadce8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxTcGFuaXNoJTIwdGFwYXN8ZW58MHx8fHwxNzc2MTEyNDEwfDA&ixlib=rb-4.1.0&q=85&w=800",

  // MENU PAGE
  menuHero: "https://customer-assets.emergentagent.com/job_redbull-redesign/artifacts/yvaz5til_Screenshot%202026-04-13%20at%2020.39.00.png",

  // CONTACT PAGE
  contactHero: "https://images.unsplash.com/photo-1773681092966-04cc821c6cea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwdGVycmFjZXxlbnwwfHx8fDE3NzYxMTI0MTl8MA&ixlib=rb-4.1.0&q=85&w=1920",
};



export const restaurantInfo = {
  name: "La Bodega",
  tagline: "Café · Restaurant · Tapas Bar",
  subtitle: "Jeder Bissen ein Geschmackserlebnis",
  address: "Bismarckstraße 16, 26757 Borkum",
  phone: "04922-8369540",
  email: "post@labodega-borkum.de",
  description: "Spanisches Flair im hohen Norden — auf dem schönsten Sandhaufen der Welt.",
  heroText: "Willkommen bei uns im La Bodega auf Borkum",
  heroSubtext: "Authentische spanische Küche & mediterrane Genüsse auf der wunderschönen Insel Borkum",
  welcomeText: "Lieber Besucher unserer Webseite, wir, das Team des Tapas-Restaurants freuen uns, Sie hoffentlich nicht nur hier im Web sondern auch bald in unserem Lokal auf der Borkumer Bismarckstraße (Nr. 16) begrüßen zu dürfen.",
  directionText: "Vom Bahnhof kommend in Richtung Meer, finden Sie uns kurz hinter der Kreuzung bei Akkermann auf der rechten Seite. Achten Sie auf das Reklameschild \"Alfredos\". Wir sind nicht zu verfehlen!",
  terraceText: "Entspannen und genießen Sie auch am Abend das Ambiente auf unserer Terrasse bei einem leckeren Essen und einem dazu passenden Getränk. Kosten Sie auf jeden Fall mal die Tapas, denn unser Koch hat deren Rezepte aus Barcelona mit nach Borkum gebracht.",
  cocktailText: "Probieren Sie auch unsere reichhaltige Auswahl an verschiedenen Cocktails, mit oder auch ohne Alkohol.",
  flairText: "Hier finden Sie spanisches Flair auch im \"hohen Norden\" auf dem \"schönsten Sandhaufen der Welt\"!"
};

export const restaurantDetails = {
  title: "Unser Restaurant",
  intro: "Die mediterrane Küche gilt als besonders gesund.",
  description: "Ausgewogenheit ist unser Programm. Etwas Fleischiges, viel frischer Fisch und Meeresfrüchte, dazu Olivenöl, Gemüse, Obst, Knoblauch, Kräuter stehen täglich auf unserem Speiseplan. Sie werden eine große Wein- und Getränke-Auswahl vorfinden.",
  coffeeText: "Hausgemachte Waffeln, Torten und Kuchen runden Ihren Kaffee, Ihren Cappuccino oder Ihre Latte Macchiato ab — und das nicht nur am Nachmittag.",
  welcomeText: "Wir heißen Sie herzlich willkommen in unserer gemütlichen Lokalität in der Bismarckstraße Nr. 16.",
  teamText: "Ihr Team vom \"La Bodega\".",
  features: [
    {
      title: "Mediterrane Küche",
      description: "Frischer Fisch, Meeresfrüchte, Olivenöl und Kräuter — authentisch mediterran.",
      icon: "UtensilsCrossed"
    },
    {
      title: "Tapas aus Barcelona",
      description: "Unser Koch hat seine besten Rezepte direkt aus Barcelona mitgebracht.",
      icon: "ChefHat"
    },
    {
      title: "Hausgemachte Kuchen",
      description: "Kuchen — frisch und hausgemacht, jeden Tag.",
      icon: "Cake"
    },
    {
      title: "Cocktails & Weine",
      description: "Eine reichhaltige Auswahl an Cocktails und erlesenen Weinen.",
      icon: "Wine"
    }
  ]
};

export const menuCategories = [
  {
    id: "tapas",
    name: "Tapas",
    description: "Zu unseren Tapas und Salaten reichen wir Baguette",
    items: [
      { name: "Baguette; Aioli mit Mojo", description: "", price: "4,00" },
      { name: "Tomete la del Sal", description: "Frische Cherrytomaten, Schalloten mit Olivenöl und eine Meersalz Selektion", price: "4,90" },
      { name: "Ensalada Mixta", description: "Gemischter Salat mit Jogurt-Dressing", price: "5,90" },
      { name: "Sardinas en Escabeche", description: "Eingelegte Sardinen mit Zwiebelringe", price: "5,00" },
      { name: "Aceitunas", description: "Verschiedene Oliven", price: "5,90" },
      { name: "Papas Arrugadas", description: "Kleine feste Kartoffeln mit kanarische Sauce", price: "6,90" },
      { name: "Pimientos de Padron", description: "Kleine frittierte Paprika aus Padron in Galicien", price: "7,90" },
      { name: "Datiles con Bacon", description: "Datteln im Speckmanteln mit Honig", price: "7,50" },
      { name: "Champinones al Ajillo", description: "Champignons im Knoblauch und Kräuter", price: "7,90" },
      { name: "Chipirones a la Romana con Aioli", description: "Frittierte Calamari dazu Aioli", price: "8,50" },
      { name: "Albondigas en Tomate", description: "Fleischbällchen in Tomatensauce", price: "8,90" },
      { name: "Chorizo con Champinones", description: "Chorizo Wurst und Champignones angeschwenkt mit Kräutern und Knoblauch", price: "9,50" },
      { name: "Gambas al Ajillo", description: "Gambas in Knoblauch-Olivenöl gebraten, scharf", price: "9,90" },
      { name: "Mejillones en Salsa Tomete", description: "Muscheln in Tomaten-Knoblauchsauce", price: "8,50" },
      { name: "Queso Horno", description: "Schafskäse aus dem Ofen mit Cherrytomaten, Oliven, Knoblauch und Paprika mild", price: "10,50" },
      { name: "Patatas Partida", description: "Kartoffelspalten mit sweet Chillisauce", price: "6,90" },
      { name: "Antipasti", description: "Verschiedene Grillgemüse", price: "10,50" }
    ]
  },
  {
    id: "hauptgerichte",
    name: "Hauptgerichte",
    description: "Mediterrane Hauptspeisen",
    items: [
      { name: "Ensalada Mixta (Vegetarisch)", description: "Großer gemischter Salat mit Joghurtdressing", price: "12,90" },
      { name: "Ensalada \u201eLa Bodega\u201c", description: "Großer bunter Salat mit Hähnchenbruststreifen, Champignons und einem Knoblauch-Dressing", price: "17,90" },
      { name: "Ensalada \u201eEspecial\u201c", description: "Großer bunter Salat mit gebratenen Gambas und einem Knoblauch-Dressing", price: "18,90" },
      { name: "Tortellini de Espinaca Ricota (Vegetarisch)", description: "Gefüllte Tortellini mit Ricotta-Spinat in Tomaten-Sahnesauce und Käse überbacken", price: "15,50" },
      { name: "Gambas Espaguetis", description: "Spaghetti mit Gambas angeschwenkt in Knoblauch-Olivenöl, garniert mit Rucola und Parmesan", price: "19,90" },
      { name: "Gratinado de Verduras (Vegetarisch)", description: "Mediterranes Gemüsegratin in Pesto Sauce mit Mozzarella überbacken", price: "14,90" },
      { name: "Piccata Milanese", description: "Vom Rotbarsch oder Schweinefilet auf Spaghetti-Tomatensauce, garniert mit Rucola und Parmesan", price: "18,90" },
      { name: "Hähnchenstreifen auf Penne-Nudeln", description: "Tomatensauce in Pesto-Knoblauch mit Cherrytomaten und Rucola, Parmesan garniert", price: "19,90" },
      { name: "Gambas Espaguetis (Tomate)", description: "Spaghetti mit Gambas angeschwenkt in Tomatensauce, garniert mit Rucola und Parmesan", price: "20,90" }
    ]
  },
  {
    id: "tagesgerichte",
    name: "Tagesgerichte",
    description: "Täglich frisch zubereitet",
    items: [
      { name: "Spaghetti Aglio e Olio", description: "Angeschwenkt mit Knoblauch und Kräuter Olivenöl, garniert mit Rucola und Parmesan", price: "13,50" },
      { name: "Pene Gorgonzola", description: "Gorgonzolasauce, Knoblauch Pesto, Kräutern, Cherrytomaten", price: "13,90" },
      { name: "Schweineschnitzel \u201eWiener Art\u201c", description: "Mit Pommes frites und Salatgarnitur", price: "14,90" },
      { name: "Schweineschnitzel \u201eBalkan Art\u201c", description: "Mit pikante Paprikasauce dazu Pommes", price: "14,90" },
      { name: "Schweineschnitzel", description: "Mit Champignonsauce dazu Pommes", price: "14,90" },
      { name: "Fischfilet aus dem Ofen", description: "Auf Kartoffel-Gemüse Ragout mit verschiedene Kräutern-Olivenöl", price: "14,90" }
    ]
  },
  {
    id: "algo-special",
    name: "Algo Special",
    description: "Unsere besonderen Empfehlungen",
    items: [
      { name: "Rumpsteak \u201eLa Bodega\u201c (150g)", description: "Champignons, Paprika, Kräuterbutter dazu reichen wir Pommes", price: "23,50" },
      { name: "Rumpsteak \u201eLa Bodega\u201c (200g)", description: "Champignons, Paprika, Kräuterbutter dazu reichen wir Pommes", price: "26,50" },
      { name: "Rumpsteak \u201eLa Bodega\u201c (250g)", description: "Champignons, Paprika, Kräuterbutter dazu reichen wir Pommes", price: "29,50" },
      { name: "Rumpsteak Salat", description: "Großer gemischter Salat mit Rumpsteak Streifen und dazu Baguette", price: "18,50" },
      { name: "Rumpsteak Streifen", description: "In Tomaten-Chillisauce dazu Baguette", price: "13,50" }
    ]
  },
  {
    id: "biere-aperitifs",
    name: "Biere & Aperitifs",
    description: "Fass- und Flaschenbiere, Aperitifs",
    items: [
      { name: "Warsteiner 0,3L", description: "", price: "4,50" },
      { name: "Warsteiner 0,4L", description: "", price: "4,90" },
      { name: "Alster 0,3L", description: "", price: "4,50" },
      { name: "Alster 0,4L", description: "", price: "4,90" },
      { name: "Warsteiner Alk. 0,33L", description: "Alkoholfrei", price: "4,50" },
      { name: "Malzbier 0,33L", description: "", price: "4,50" },
      { name: "Weizbier 0,5L", description: "Hell, Dunkel, Alkoholfrei", price: "5,90" },
      { name: "Glas Sekt 0,1L", description: "", price: "4,50" },
      { name: "Glas Prosecco 0,1L", description: "", price: "4,50" },
      { name: "Martini Weiß 5cl", description: "", price: "5,50" },
      { name: "Aperol Spritz 0,2L", description: "", price: "8,50" },
      { name: "Sanddorn Spritz 0,2L", description: "", price: "8,50" },
      { name: "Hugo 0,2L", description: "", price: "8,50" },
      { name: "Lillet 0,2L", description: "", price: "8,50" },
      { name: "Campari Orange 0,2L", description: "", price: "8,50" }
    ]
  },
  {
    id: "soft-saefte",
    name: "Soft Getränke & Säfte",
    description: "Alkoholfreie Erfrischungen",
    items: [
      { name: "Coca Cola 0,3L", description: "", price: "4,00" },
      { name: "Coca Cola Light 0,3L", description: "", price: "4,00" },
      { name: "Fanta 0,3L", description: "", price: "4,00" },
      { name: "Spezi 0,3L", description: "", price: "4,00" },
      { name: "Bitter Lemon 0,3L", description: "", price: "4,00" },
      { name: "Ginger Ale 0,3L", description: "", price: "4,00" },
      { name: "Vilsa 0,25L", description: "", price: "3,50" },
      { name: "Vilsa 0,75L", description: "", price: "6,90" },
      { name: "Alle Soft Getränke 0,4L", description: "", price: "4,90" },
      { name: "Apfelsaft 0,3L", description: "", price: "4,50" },
      { name: "Orangesaft 0,3L", description: "", price: "4,50" },
      { name: "Kirschsaft 0,3L", description: "", price: "4,50" },
      { name: "Johannisbeersaft 0,3L", description: "", price: "4,50" },
      { name: "Alle Säfte 0,4L", description: "", price: "4,90" },
      { name: "Saftschorle 0,3L", description: "Alle Säfte auch als Schorle", price: "4,00" }
    ]
  },
  {
    id: "kaffee-tee",
    name: "Kaffee & Heiße Getränke",
    description: "Warm und gemütlich",
    items: [
      { name: "Espresso", description: "", price: "3,00" },
      { name: "Espresso doppelt", description: "", price: "4,50" },
      { name: "Tasse Kaffee", description: "", price: "3,80" },
      { name: "Pott Kaffee", description: "", price: "4,00" },
      { name: "Cappuccino", description: "", price: "4,50" },
      { name: "Latte Macchiato", description: "", price: "4,50" },
      { name: "Milchkaffee", description: "", price: "4,50" },
      { name: "Glas Tee", description: "Diverse Sorten", price: "3,50" },
      { name: "Sanddorngrog 4cl", description: "", price: "5,50" },
      { name: "Grog mit Rum 4cl", description: "", price: "5,50" },
      { name: "Glühwein", description: "", price: "5,50" },
      { name: "Kakao ohne Sahne", description: "", price: "5,50" },
      { name: "Kakao mit Sahne", description: "", price: "5,90" },
      { name: "Lumumba", description: "", price: "6,90" },
      { name: "Kakao Baileys", description: "", price: "6,90" },
      { name: "Pharisäer", description: "", price: "6,90" },
      { name: "Irish Coffee", description: "", price: "6,90" }
    ]
  },
  {
    id: "cocktails-spirituosen",
    name: "Cocktails & Spirituosen",
    description: "Cocktails, Digestiv, Whiskey & mehr",
    items: [
      { name: "Cuba Libre", description: "", price: "8,50" },
      { name: "Caipirinha", description: "", price: "8,50" },
      { name: "Pina Colada", description: "", price: "9,50" },
      { name: "Tequila Sunrise", description: "", price: "8,50" },
      { name: "Mojito", description: "", price: "8,50" },
      { name: "Küstennebel 2cl", description: "Digestiv", price: "3,50" },
      { name: "Fürst Bismarck 2cl", description: "Digestiv", price: "3,50" },
      { name: "Kruiden 2cl", description: "Digestiv", price: "3,50" },
      { name: "Ouzo 2cl", description: "Digestiv", price: "3,50" },
      { name: "Sanddorn 2cl", description: "Digestiv", price: "3,50" },
      { name: "Grappa 2cl", description: "Digestiv", price: "3,50" },
      { name: "Friesengeist 2cl", description: "Digestiv", price: "3,50" },
      { name: "Tullamore Dew 4cl", description: "Whiskey", price: "5,50" },
      { name: "Ballantines 4cl", description: "Whiskey", price: "5,50" },
      { name: "Jack Daniels 4cl", description: "Whiskey", price: "5,50" },
      { name: "Jägermeister 2cl", description: "Bitter", price: "3,50" },
      { name: "Fernet Branca 2cl", description: "Bitter", price: "3,50" },
      { name: "Ramazzotti 2cl", description: "Bitter", price: "3,50" },
      { name: "Averna 2cl", description: "Bitter", price: "3,50" },
      { name: "Linie 2cl", description: "Aguavite", price: "3,50" },
      { name: "Jubi 2cl", description: "Aguavite", price: "3,50" },
      { name: "Malteser 2cl", description: "Aguavite", price: "3,50" },
      { name: "Veterano 2cl", description: "Aguavite", price: "4,50" },
      { name: "Sambuca 2cl", description: "Aguavite", price: "3,50" },
      { name: "Tequila 2cl", description: "Aguavite", price: "3,50" }
    ]
  },
  {
    id: "kindermenu",
    name: "Für unsere kleinen Gäste",
    description: "Kindergerichte",
    items: [
      { name: "\u201eHab keinen Hunger...\u201c", description: "Chicken Nuggets mit Pommes (Ketchup und Mayo)", price: "9,30" },
      { name: "\u201eIch weiß nicht...\u201c", description: "Spaghetti mit Tomatensauce", price: "8,30" }
    ]
  },
  {
    id: "desserts",
    name: "Desserts",
    description: "Süße Verführungen",
    items: [
      { name: "Panna Cotta", description: "", price: "7,00" },
      { name: "Schokosouffle", description: "", price: "8,00" },
      { name: "Vanilleeis mit heiße Kirschen", description: "", price: "8,00" }
    ]
  }
];

export const galleryImages = [
  {
    src: "https://images.unsplash.com/photo-1656423521731-9665583f100c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxTcGFuaXNoJTIwdGFwYXN8ZW58MHx8fHwxNzc2MTEyNDEwfDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Tapas Auswahl",
    category: "tapas"
  },
  {
    src: "https://images.unsplash.com/photo-1672636401225-ec3d4025a4af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxNZWRpdGVycmFuZWFuJTIwY3Vpc2luZXxlbnwwfHx8fDE3NzYxMTI0MTV8MA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Mediterrane Meeresfrüchte",
    category: "hauptgerichte"
  },
  {
    src: "https://images.unsplash.com/photo-1653611540493-b3a896319fbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxNZWRpdGVycmFuZWFuJTIwY3Vpc2luZXxlbnwwfHx8fDE3NzYxMTI0MTV8MA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Mediterrane Küche",
    category: "hauptgerichte"
  },
  {
    src: "https://images.unsplash.com/photo-1565599837634-134bc3aadce8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxTcGFuaXNoJTIwdGFwYXN8ZW58MHx8fHwxNzc2MTEyNDEwfDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Frittierte Tapas",
    category: "tapas"
  },
  {
    src: "https://images.unsplash.com/photo-1730411317769-b991ec3951d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb2ZmZWUlMjBjYXBwdWNjaW5vfGVufDB8fHx8MTc3NjExMjQyNXww&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Cappuccino",
    category: "getraenke"
  },
  {
    src: "https://images.unsplash.com/photo-1609951651556-5334e2706168?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxjb2NrdGFpbHN8ZW58MHx8fHwxNzc2MTEyNDI4fDA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Cocktail",
    category: "getraenke"
  },
  {
    src: "https://images.pexels.com/photos/605408/pexels-photo-605408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Cocktail Auswahl",
    category: "getraenke"
  },
  {
    src: "https://images.unsplash.com/photo-1773681092966-04cc821c6cea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwdGVycmFjZXxlbnwwfHx8fDE3NzYxMTI0MTl8MA&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Unsere Terrasse",
    category: "restaurant"
  }
];

export const navLinks = [
  { name: "Startseite", path: "/" },
  { name: "Restaurant", path: "/restaurant" },
  { name: "Speisekarte", path: "/speisekarte" },
  { name: "Kontakt", path: "/kontakt" }
];

export const openingHours = [
  { day: "Montag", hours: "12:00 — 22:00" },
  { day: "Dienstag", hours: "12:00 — 22:00" },
  { day: "Mittwoch", hours: "12:00 — 22:00" },
  { day: "Donnerstag", hours: "12:00 — 22:00" },
  { day: "Freitag", hours: "12:00 — 22:00" },
  { day: "Samstag", hours: "12:00 — 22:00" },
  { day: "Sonntag", hours: "12:00 — 22:00" }
];

export const kitchenHours = "Warme Küche gibt es von 12:00 Uhr bis 21:30 Uhr.";
